export default __webpack_public_path__ + "static/media/step1.55e188ba.png";